module.exports = __webpack_public_path__ + "media/spring_tip_3-7e42a1cb4718b550ffc252e512be033b.mp3";